import { ServiceBase } from '../../../core/services/ServiceBase'
import LibraryProxy from './proxy'

class LibraryService extends ServiceBase {
  //SavePortfolio
  getHeaderSavedPortfolio(params) {
    return this.getData(() => LibraryProxy.getHeaderSavedPortfolio(params))
  }
  getAlertProfile(params) {
    return this.getData(() => LibraryProxy.getAlertProfile(params))
  }
  putUpdateAlertProfile(params) {
    return this.getData(() => LibraryProxy.putUpdateAlertProfile(params), true)
  }
  postCreatePortfolio(params) {
    return this.getData(() => LibraryProxy.postCreatePortfolio(params))
  }
  putUpdateNamePortfolio(params) {
    return this.getData(() => LibraryProxy.putUpdateNamePortfolio(params), true)
  }
  getSearchPortfolio(params) {
    return this.getData(() => LibraryProxy.getSearchPortfolio(params))
  }
  delDeletePortfolio(params) {
    return this.getData(() => LibraryProxy.delDeletePortfolio(params), true)
  }
  getSearchCompany(params) {
    return this.getData(() => LibraryProxy.getSearchCompany(params))
  }
  getSavedPortfolioByOrg(params) {
    return this.getData(() => LibraryProxy.getSavedPortfolioByOrg(params))
  }
  downloadSavedPortfolio(params) {
    return this.getFileDownload(() =>
      LibraryProxy.downloadSavedPortfolio(params),
    )
  }
  postDuplicatePortfolio(params) {
    return this.getData(() => LibraryProxy.postDuplicatePortfolio(params), true)
  }
  getSearchPortfolioAll(params) {
    return this.getData(() => LibraryProxy.getSearchPortfolioAll(params))
  }
  getIdPortfolioAllByOrg(params) {
    return this.getData(() => LibraryProxy.getIdPortfolioAllByOrg(params))
  }

  //SavePortfolio Detail
  getHeaderSavedPortfolioDetail(params) {
    return this.getData(() =>
      LibraryProxy.getHeaderSavedPortfolioDetail(params),
    )
  }
  getSearchCompanyInPortfolioDetails(params) {
    return this.getData(() =>
      LibraryProxy.getSearchCompanyInPortfolioDetails(params),
    )
  }
  putUpdateAlertCompany(params) {
    return this.getData(() => LibraryProxy.putUpdateAlertCompany(params))
  }
  delDeleteCompany(params) {
    return this.getData(() => LibraryProxy.delDeleteCompany(params), true)
  }
  downloadPortfolioDetail(params) {
    return this.getFileDownload(() =>
      LibraryProxy.downloadPortfolioDetail(params),
    )
  }
  postAddNewCompany(params) {
    return this.getData(() => LibraryProxy.postAddNewCompany(params), true)
  }
  postImportExcel(params) {
    return this.getData(() => LibraryProxy.postImportExcel(params))
  }
  downloadFilteredCompanies(params) {
    return this.getFileDownload(() =>
      LibraryProxy.downloadFilteredCompanies(params),
    )
  }
  getAllIdCompanyInPortfolio(params) {
    return this.getData(() => LibraryProxy.getAllIdCompanyInPortfolio(params))
  }

  //FilterCompanies
  getFilteredCompanies(params) {
    return this.getData(() => LibraryProxy.getFilteredCompanies(params))
  }
  downloadTemplateImportCompany(params) {
    return this.getFileDownload(() =>
      LibraryProxy.downloadTemplateImportCompany(params),
    )
  }
  getAllIdCompanyFilter(params) {
    return this.getData(() => LibraryProxy.getAllIdCompanyFilter(params))
  }

  //FilterCompanies Setting
  getCompanies(params) {
    return this.getData(() => LibraryProxy.getCompanies(params))
  }

  //Download File
  getFileCategory(params) {
    return this.getData(() => LibraryProxy.getFileCategory(params))
  }
  getDownloadFile(params) {
    return this.getData(() => LibraryProxy.getDownloadFile(params))
  }
  getTypeReportFileFormat(params) {
    return this.getData(() => LibraryProxy.getTypeReportFileFormat(params))
  }
  downloadTemplate(params) {
    return this.getFileDownload(() => LibraryProxy.downloadTemplate(params))
  }
  getHeaderDownloadFile(params) {
    return this.getData(() => LibraryProxy.getHeaderDownloadFile(params))
  }

  //Following List
  getSearchCompanyInFollowList(params) {
    return this.getData(() => LibraryProxy.getSearchCompanyInFollowList(params))
  }
  delUnFollow(params) {
    return this.getData(() => LibraryProxy.delUnFollow(params))
  }
  getHeaderFollow(params) {
    return this.getData(() => LibraryProxy.getHeaderFollow(params))
  }
  getAllIdFollow(params) {
    return this.getData(() => LibraryProxy.getAllIdFollow(params))
  }
  //MoveAndCoppy
  postMoveOrCopyCompany(params) {
    return this.getData(() => LibraryProxy.postMoveOrCopyCompany(params))
  }
  postCopyCompany(params) {
    return this.getData(() => LibraryProxy.postCopyCompany(params))
  }
  //Score Range
  getScoreRangesCreditRisk(params) {
    return this.getData(() => LibraryProxy.getScoreRangesCreditRisk(params))
  }
  getScoreRangesPerformance(params) {
    return this.getData(() => LibraryProxy.getScoreRangesPerformance(params))
  }
}

export default new LibraryService()
